export const SPORT = {
  SOCCER: 'soccer',
} as const;

export type Sport = ConstType<typeof SPORT>;
